import { Link } from "react-router-dom";
import { NewsPreview } from "../components/NewsPreview";
import { useAuth } from "../../gym/auth/useAuth";

function GymIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <line x1="6.5" y1="12" x2="17.5" y2="12" />
      <rect x="3" y="9" width="3" height="6" rx="1" />
      <rect x="18" y="9" width="3" height="6" rx="1" />
      <rect x="5.5" y="7" width="1.6" height="10" rx="0.6" />
      <rect x="16.9" y="7" width="1.6" height="10" rx="0.6" />
    </svg>
  );
}

function BenefitsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
}

function CafeteriaIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
      <path d="M7 2v20" />
      <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
    </svg>
  );
}

function PoliciesIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
      <path d="M14 2v6h6" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="16" y2="17" />
    </svg>
  );
}

function NewsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Z" />
      <path d="M17 8h2a1 1 0 0 1 1 1v9a2 2 0 0 1-2 2" />
      <rect x="7" y="7" width="5" height="4" rx="0.5" />
      <line x1="7" y1="14" x2="15" y2="14" />
      <line x1="7" y1="17" x2="15" y2="17" />
    </svg>
  );
}

function SpeakUpIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z" />
    </svg>
  );
}

// hidden: true keeps a tile out of the launch lineup without deleting it — flip it back
// to false (or drop the property) to bring the widget back once that module is ready.
const tiles = [
  { to: "/benefits", label: "Benefits", desc: "Health cover, allowances & perks", icon: <BenefitsIcon /> },
  { to: "/gym", label: "Gym", desc: "On-site fitness & class schedule", icon: <GymIcon />, hidden: true },
  { to: "/cafeteria", label: "Cafeteria", desc: "Meal wallet, QR pay & menu", icon: <CafeteriaIcon /> },
  { to: "/policies", label: "Policies and Procedures", desc: "Guidelines & company handbook", icon: <PoliciesIcon /> },
  { to: "/news", label: "News", desc: "Company announcements & updates", icon: <NewsIcon />, hidden: true },
];

const SHOW_NEWS_PREVIEW = false;

export function LandingPage() {
  const { isAdmin } = useAuth();

  return (
    <div className="landing">
      <div className="landing-hero">
        <h1 className="landing-title">Welcome</h1>
        <p className="landing-sub">Choose where you&rsquo;d like to go.</p>

        <Link to="/speakup" className="landing-speakup-fab">
          <SpeakUpIcon />
          Speak Up
        </Link>

        {isAdmin && (
          <Link to="/admin/analytics" className="btn btn-ghost landing-analytics-link">
            Page view analytics
          </Link>
        )}
      </div>

      <div className="landing-tiles">
        {tiles
          .filter((tile) => !tile.hidden)
          .map((tile) => (
            <Link key={tile.to} to={tile.to} className="landing-tile">
              <span className="landing-tile-icon">{tile.icon}</span>
              <span className="landing-tile-label">{tile.label}</span>
              <p className="landing-tile-desc">{tile.desc}</p>
            </Link>
          ))}
      </div>

      {/* News module not launched yet — flip this back on alongside its tile above. */}
      {SHOW_NEWS_PREVIEW && <NewsPreview />}
    </div>
  );
}
